/**
 * Action creators for managing the Electronic Scale state.
 *
 * The following functions provide actions to be dispatched to Redux store
 * for modifying the electronic scale state based on provided data.
 */

export interface UpdateProtocolExampleAction {
  type: "UPDATE_PROTOCOL_EXAMPLE";
  payload: {
    example: string;
  };
}

export interface SetCurrentWeightAction {
  type: "SET_CURRENT_WEIGHT";
  payload: number;
}

export interface SetTubesOnScaleAction {
  type: "SET_TUBES_ON_SCALE";
  payload: boolean[];
}

export interface SetTubeMappingToBeakerAction {
  type: "SET_TUBE_MAPPING_TO_BEAKER";
  payload: number[];
}

export interface SetTubeBeakerNumberAction {
  type: "SET_TUBE_BEAKER_NUMBER";
  payload: string[];
}

export interface SetWeightsPreDialysisAction {
  type: "SET_WEIGHTS_PRE_DIALYSIS";
  payload: number[];
}

export interface SetWeightsPostDialysisAction {
  type: "SET_WEIGHTS_POST_DIALYSIS";
  payload: number[];
}

export interface ShowTooltipAction {
  type: "SHOW_RECORD_BUTTON_TOOLTIP";
  payload: any;
}

export interface HideTooltipAction {
  type: "HIDE_RECORD_BUTTON_TOOLTIP";
  payload: any;
}

export interface SetMassRecordedAction {
  type: "SET_PREMASS_RECORDED";
  payload: any;
}

export type ElectronicScaleAction =
  | UpdateProtocolExampleAction
  | SetCurrentWeightAction
  | SetTubesOnScaleAction
  | SetTubeMappingToBeakerAction
  | SetTubeBeakerNumberAction
  | SetWeightsPreDialysisAction
  | SetWeightsPostDialysisAction
  | ShowTooltipAction
  | HideTooltipAction
  | SetMassRecordedAction;

/**
 * updateProtocolExample creates an action to update the protocol example.
 *
 * @param data - The data for the update protocol example action.
 * @param data.example - The example string that needs to be updated.
 * @returns The action object with type and payload.
 */
export const updateProtocolExample = (data: {
  example: string;
}): UpdateProtocolExampleAction => {
  return { type: "UPDATE_PROTOCOL_EXAMPLE", payload: data };
};

export const setCurrentWeight = (data: number): SetCurrentWeightAction => {
  return { type: "SET_CURRENT_WEIGHT", payload: data };
};

export const setTubesOnScale = (data: boolean[]): SetTubesOnScaleAction => {
  return { type: "SET_TUBES_ON_SCALE", payload: data };
};

export const setTubeMappingtoBeaker = (
  data: number[]
): SetTubeMappingToBeakerAction => {
  return { type: "SET_TUBE_MAPPING_TO_BEAKER", payload: data };
};

export const setTubeBeakerNumber = (
  data: string[]
): SetTubeBeakerNumberAction => {
  return { type: "SET_TUBE_BEAKER_NUMBER", payload: data };
};

export const setWeightsPreDialysis = (
  data: number[]
): SetWeightsPreDialysisAction => {
  return { type: "SET_WEIGHTS_PRE_DIALYSIS", payload: data };
};

export const setWeightsPostDialysis = (
  data: number[]
): SetWeightsPostDialysisAction => {
  return { type: "SET_WEIGHTS_POST_DIALYSIS", payload: data };
};

export const showTooltip = (data?: any): ShowTooltipAction => {
  return { type: "SHOW_RECORD_BUTTON_TOOLTIP", payload: data };
};

export const hideTooltip = (data?: any): HideTooltipAction => {
  return { type: "HIDE_RECORD_BUTTON_TOOLTIP", payload: data };
};

export const setMassRecorded = (data: any): SetMassRecordedAction => {
  return { type: "SET_PREMASS_RECORDED", payload: data };
};
